import React from "react";
import March24Tag from "./../../assets/march'24.svg";

export const March24 = ({ className, title, isValidProject }) => {
  return isValidProject ? (
    <div className={className}>
      <img src={March24Tag} />
    </div>
  ) : null;
};
